
export default class Card {
    
    static get selector() {
        return '.card';
    }

    constructor(el) {
        this.el = el;
        this.setEvents();
    }

    setEvents() {
        this.el.addEventListener('mousemove', this.e_mouseMove.bind(this));
    }

    updatePosition(x,y) {
        this.el.style.setProperty('--x', Math.round(x) +'px');
        this.el.style.setProperty('--y', Math.round(y) +'px');
    }

    
    e_mouseMove(e){
        let rect = this.el.getBoundingClientRect();
        this.updatePosition(e.clientX - rect.left,e.clientY - rect.top);
    }

 

}